// One place that turns a profiled entity's backend name into product language.
//
// The backend sends `table_name` / `entity` as snake_case plural — it is also the
// URL param, so it cannot be prettified server-side without breaking the API.
// Three components used to title-case it independently (QualityOverview's own
// map, RunEntityBreakdown's titleCase, CompletenessTrend's inline one), which is
// why adding entities to dataquality.Contract() produced "Companies, People,
// Jobs, Activities, Person_employments, Job_candidates" on the History tab and
// correct labels on Quality.
//
// An entity with no entry here falls back to title-cased snake_case, so a new
// one is readable on day one and nameable on day two.

// Recruiter vocabulary, not ours. Two of these were renamed after review:
//
//   person_employments  was "Work history"  -> "Employment history"
//   job_candidates      was "Candidacies"   -> "Candidate pipeline"
//
// "Candidacies" is not a word recruiters use. The obvious alternatives are both
// wrong: "Submissions" names ONE stage of the ladder (submitted) and most rows
// never reach it, and "Applications" implies the candidate applied when most are
// sourced. "Candidate pipeline" keeps the qualifier deliberately — bare
// "Pipeline" already means the INGEST pipeline on this same page.
const ENTITY_LABEL = {
  companies: 'Companies',
  people: 'People',
  jobs: 'Jobs',
  activities: 'Activities',
  person_employments: 'Employment history',
  job_candidates: 'Candidate pipeline',
  job_candidate_events: 'Pipeline history',
  job_candidate_stages: 'Pipeline stages',
  tenant_employees: 'Your team',
};

/** entityLabel('person_employments') -> 'Employment history'; unknown -> 'Some thing'. */
export function entityLabel(name) {
  if (!name) return name;
  if (ENTITY_LABEL[name]) return ENTITY_LABEL[name];
  const spaced = String(name).replace(/_/g, ' ');
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}

export default ENTITY_LABEL;
